import { useContext } from "react";
import GlobalContext from "../../../context/Global";
import { sentenceCase } from "change-case";

export const useLocale = () => {
	const { locale, toggleLocale, setLocale } = useContext(GlobalContext);

	const localePrice = (amount: number) => {
		if (!amount) return "-";
		let sign = "";
		if (amount < 0) {
			sign = "-";
			amount *= -1;
		}
		const fixedAmount = amount.toFixed(2);

		if (locale === "en-US") return `${sign}$${fixedAmount}`;
		return `${sign}${fixedAmount.replace(".", ",")} $`;
	};
	const localeCase = (text?: string) => {
		if (!text) return text;
		if (locale === "en-US" || locale === "en-CA" || locale === "en")
			return text;
		const indexMap: { [key: string]: number[] } = { "-": [], "’": [] };
		for (const token in indexMap)
			text.split("").forEach((c, i) => c === token && indexMap[token].push(i));

		const transformed = sentenceCase(text).split("");

		for (const token in indexMap)
			indexMap[token].forEach((i) => (transformed[i] = token));
		return transformed.join("");
	};
	return { locale, toggleLocale, setLocale, localePrice, localeCase };
};
